import { Component, Input, OnInit } from '@angular/core';
import { ClubCentricClassItem, ClubCentricClubSummaryItem } from '../../../models/club-centric-report-model';

@Component({
    selector: 'app-club-centric-report-item',
    templateUrl: './club-centric-report-item.component.html',
    styleUrls: ['./club-centric-report-item.component.scss'],
    standalone: false
})
export class ClubCentricReportItemComponent implements OnInit {
    @Input()
    summaryItem: ClubCentricClubSummaryItem;
    constructor() {}

    ngOnInit() {}

    public attendanceProvided(item: ClubCentricClassItem): boolean {
        return item.classAttendance !== null;
    }
}
